import React from "react";
import Jumbotron from "../components/Jumbotron";
import SubNav from "../components/sub-nav";
import StudentList from "../components/StudentList";
import StudyWithUs from "../components/study-with-us";
import styles from "../styles/students.module.scss";
import CallToAction from "../components/CallToAction";
import PageWrapper from "../components/PageWrapper";
import Helmet from "react-helmet";

// const Students = props => {
class Students extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tab: "current"
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		const { props } = this;
		const { location } = nextProps;

		if (nextState.currentCat !== this.state.currentCat) {
			return true;
		}
		return (
			location.pathname !== props.location.pathname ||
			location.hash !== props.location.hash
		);
	}

	componentWillReceiveProps(nextProps) {
		const oldHashCategory = this.props.location.hash.slice(1);
		const newHashCategory = nextProps.location.hash.slice(1);

		if (oldHashCategory !== newHashCategory && newHashCategory.length > 0) {
			this.setState({ tab: newHashCategory });
		}
	}

	componentDidMount() {
		const hashCategory = this.props.location.hash.slice(1);

		if (hashCategory.length > 0) {
			this.setState({ tab: hashCategory });
		}
	}

	handleClick = category => {
		const locale = this.props.data.contentfulResearchPage.node_locale;
		navigateTo({ pathname: `/${locale}/students`, hash: category });
	};

	render() {
		const { props } = this;
		const { transition, data } = props;
		const {
			pageSettings,
			cta,
			bottomBanner,
			alumMsc,
			alumPhd,
			currentMsc,
			currentPhd
		} = data;
		const workWithUs = bottomBanner.edges[0].node;

		const navList = [
			{
				label:
					pageSettings.node_locale === "th"
						? "นักศึกษาปัจจุบัน"
						: "Current Students",
				name: "current",
				href: "students"
			},
			{
				label:
					pageSettings.node_locale === "th" ? "ศิษย์เก่า" : "Alumni",
				name: "alumni",
				href: "students"
			}
		];

		return (
			<PageWrapper
				locale={pageSettings.node_locale}
				location={this.props.location}
				data={data.layout.edges[0].node}
			>
				<main role="main" style={transition && transition.style}>
				<Helmet title={pageSettings.pageTitle  + " | Mahidol Vivax Research Unit"} />
					<Jumbotron
						type="jumbotron_b"
						bottomLine={true}
						className="mb-0"
						textAlign="text-center"
						contentAlign="justify-content-md-center"
					>
						<h1 className={styles.jumbo_h1}>
							{pageSettings.pageTitle || "Students &amp; Alumni"}
						</h1>
					</Jumbotron>

					<div
						className="container"
						style={{ transform: "translateY(-50%)" }}
					>
						<div className="row justify-content-center">
							<div className="col-12 col-lg-10">
								<SubNav
									active={this.state.tab}
									scroll={false}
									offset={-100}
									locale={pageSettings.node_locale}
									navList={navList}
									handleClick={this.handleClick}
								/>
							</div>
						</div>
					</div>
					<div className={ styles.grey_wrapper}>
						<div
							className={
								" " +
								(this.state.tab === "current"
									? styles.tab_opportunities_visible
									: styles.tab_opportunities)
							}
						>
							<div className={"container " + styles.students_wrapper}>
	
								{currentPhd && (
									<div className="white_bg py-2 pt-5 py-lg-5">
										<div className="row no-gutters justify-content-center">
											<div className="col-12 col-md-10">
												<h2 className={styles.h2}>
													{pageSettings.node_locale ===
													"th"
														? "นักศึกษาปัจจุบัน"
														: "Current Students"}
												</h2>
											</div>
	
											<div className="col-12 col-md-10">
												<h3 className={styles.list_title}>
													Ph.D
												</h3>
											</div>
	
											<div className="col-12 col-md-10">
												<StudentList
													list={currentPhd.edges}
												/>
											</div>
										</div>
									</div>
								)}
								{currentMsc && (
									<div className="white_bg pt-4 pb-5 ">
										<div className="row no-gutters justify-content-center">
											<div className="col-12 col-md-10">
												<h3 className={styles.list_title}>
													MSc.
												</h3>
											</div>
	
											<div className="col-12 col-md-10">
												<StudentList
													list={currentMsc.edges}
												/>
											</div>
										</div>
									</div>
								)}
	
								{!currentPhd &&
									!currentMsc && (
										<div className=" mb-5">
											<div className="row white_bg  no-gutters justify-content-center">
												<div className="col-12 col-md-10">
													<h2 className={styles.h2}>
														{pageSettings.node_locale ===
														"th"
															? "ศิษย์เก่า"
															: "Alumni"}
													</h2>
												</div>
	
												<div className="col-12 col-md-10 text-center">
													<h3
														className={
															styles.list_title
														}
													>
														Sorry, we haven't added any
														Alumni yet
													</h3>
												</div>
											</div>
										</div>
									)}
							</div>
						</div>
						<div
							className={
								(this.state.tab === "alumni"
									? styles.tab_students_visible
									: styles.tab_students)
							}
						>
							<div className={"container " + styles.students_wrapper}>
								{alumPhd && (
									<div className="white_bg py-2 pt-5 py-lg-5">
										<div className="row  no-gutters justify-content-center">
											<div className="col-12 col-md-10">
												<h2 className={styles.h2}>
													{pageSettings.node_locale ===
													"th"
														? "ศิษย์เก่า"
														: "Alumni"}
												</h2>
											</div>
	
											<div className="col-12 col-md-10">
												<h3 className={styles.list_title}>
													Ph.D
												</h3>
											</div>
	
											<div className="col-12 col-md-10">
												<StudentList
													list={alumPhd.edges}
													alumni={true}
												/>
											</div>
										</div>
									</div>
								)}
								{alumMsc && (
									<div className="white_bg pt-4 pb-5">
										<div className="row  no-gutters justify-content-center">
											<div className="col-12 col-md-10">
												<h3 className={styles.list_title}>
													MSc.
												</h3>
											</div>
	
											<div className="col-12 col-md-10">
												<StudentList list={alumMsc.edges} />
											</div>
										</div>
									</div>
								)}
	
								{!alumPhd &&
									!alumMsc && (
										<div className="container mb-5">
											<div className="row no-gutters justify-content-center">
												<div className="col-12 col-md-10">
													<h2 className={styles.h2}>
														{pageSettings.node_locale ===
														"th"
															? "ศิษย์เก่า"
															: "Alumni"}
													</h2>
												</div>
	
												<div className="col-12 col-md-10 text-center">
													<h3
														className={
															styles.list_title
														}
													>
														Sorry, we haven't added any
														Alumni yet
													</h3>
												</div>
											</div>
										</div>
									)}
							</div>
						</div>
					</div>
			
					<CallToAction
						className="my-5"
						text={
							cta.edges[0].node.content.childMarkdownRemark.html
						}
						buttonLabel={cta.edges[0].node.buttonLabel}
						destination={`/${pageSettings.node_locale}${
							cta.edges[0].node.linkTo
						}`}
						arrow={true}
					/>

					{/* <StudyWithUs featuredImage="student_CTA.jpg" description="MVRU offers opportunities to study various aspects of malaria research, including epidemiology and ecology, spatial and temporal dynamics, molecular methods of disease diagnostics, drug resistance surveillance and mechanisms, transmission blocking vaccines (TMB vaccines). Students will receive advanced training in spatial genetics, modeling and omics technologies such as genomics, proteomics, and metabolomics. With our strong network of collaborators, MVRU’s students are guided by experts internationally as well as in Thailand. Students will also have access to various training workshops in the following themes: statistics, modeling and spatial genetics, disease diagnostics, molecular and sero-epidemiology."/> */}

					<StudyWithUs
						title={workWithUs.title}
						featuredImage={workWithUs.bannerImage}
						description={workWithUs.text.content.html}
					/>
				</main>
			</PageWrapper>
		);
	}
}

export default Students;

export const query = graphql`
	query StudentsPageQuery($id: String!, $locale: String!) {
		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		pageSettings: contentfulStudentsPage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}

		currentMsc: allContentfulStudent(
			limit: 25
			filter: {
				node_locale: { eq: $locale }
				degree: { eq: "MSc" }
				isAlumni: { eq: false }
			}
		) {
			edges {
				node {
					isAlumni
					name
					degree
					slug
					researchSubject {
						content: researchSubject
					}
					node_locale
					title
				}
			}
		}
		currentPhd: allContentfulStudent(
			limit: 25
			filter: {
				node_locale: { eq: $locale }
				degree: { eq: "PhD" }
				isAlumni: { eq: false }
			}
		) {
			edges {
				node {
					isAlumni
					name
					degree
					slug
					researchSubject {
						content: researchSubject
					}
					node_locale
					title
				}
			}
		}
		alumMsc: allContentfulStudent(
			limit: 25
			filter: {
				node_locale: { eq: $locale }
				degree: { eq: "MSc" }
				isAlumni: { eq: true }
			}
		) {
			edges {
				node {
					isAlumni
					name
					degree
					slug
					node_locale
					title
					graduationYear
					finalThesis {
						content: finalThesis
					}
					currentPosition {
						content: currentPosition
					}
				}
			}
		}
		alumPhd: allContentfulStudent(
			limit: 25
			filter: {
				node_locale: { eq: $locale }
				degree: { eq: "PhD" }
				isAlumni: { eq: true }
			}
		) {
			edges {
				node {
					isAlumni
					name
					degree
					slug
					node_locale
					title
					graduationYear
					finalThesis {
						content: finalThesis
					}
					currentPosition {
						content: currentPosition
					}
				}
			}
		}

		cta: allContentfulCallToAction(
			filter: {
				pageLocation: { eq: "study" }
				node_locale: { eq: $locale }
			}
		) {
			edges {
				node {
					id
					pageLocation
					leadingText
					content {
						childMarkdownRemark {
							html
						}
					}
					linkTo
					buttonLabel
				}
			}
		}

		bottomBanner: allContentfulWhyStudyBanner(
			filter: { node_locale: { eq: $locale } }
		) {
			edges {
				node {
					id
					title
					text {
						content: childMarkdownRemark {
							html
						}
					}
					bannerImage {
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							srcWebp
							srcSetWebp
							sizes
						}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/students-template.js